// The information contained in this document are the sole property of LivingPackets. Any disclosure to any third party and any reproduction, in part or whole without the written permission of LivingPackets is prohibited
// Confidential - Copyright LivingPackets: All rights reserved

import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { ClosureRequest } from '../types';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { QueryConfig } from '@/lib/react-query';

const getClosureRequest = async ({
  partnerId,
  makeRequest,
}: {
  partnerId?: string;
  makeRequest: any;
}): Promise<ClosureRequest | null> => {
  const { data, error } = await makeRequest({
    path: `/partners/${partnerId}/closure-request`,
  });

  // Not found ==> no closure request
  if (error && error.status === 404) {
    return null;
  }

  if (error) {
    throw new Error(error);
  }

  return data;
};

type QueryFnType = typeof getClosureRequest;

type UsePartnerClosureRequestOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const usePartnerClosureRequest = ({
  config,
}: UsePartnerClosureRequestOptions = {}) => {
  const { id: partnerId } = useParams() as { id: string };

  const [, makeRequest] = useImperativeRequestWrapper('lpVillageV3');

  return useQuery({
    ...config,
    queryKey: ['partners', partnerId, 'closure-request'],
    queryFn: () => getClosureRequest({ partnerId, makeRequest }),
  });
};
